export default __webpack_public_path__ + "static/media/empty_mails.4a18722a.png";